package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.addQueryParam
import com.fsryan.foundation.net.client.queryParamValues
import com.fsryan.foundation.net.client.replacePathParams

abstract class WMYearBoundRequestBuilder<B: WMYearBoundRequestBuilder<B>>(protected val yearBoundsRequired: Boolean = true): FSRequestBuilder<B, Nothing>() {

    private var startYear: Int? = null
    private var yearCount: Int? = null

    fun startYear(startYear: Int): B {
        this.startYear = startYear
        return self()
    }

    fun yearCount(yearCount: Int): B {
        this.yearCount = yearCount
        return self()
    }

    override fun applyFrom(request: FSRequest<Nothing>): B {
        request.queryParamValues(QUERY_PARAM_START_YEAR)
            .firstNotNullOfOrNull { it.toIntOrNull() }
            ?.let { startYear = it }
        request.queryParamValues(QUERY_PARAM_YEAR_COUNT)
            .firstNotNullOfOrNull { it.toIntOrNull() }
            ?.let { yearCount = it }
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        removeQueryParams(QUERY_PARAM_START_YEAR)
        removeQueryParams(QUERY_PARAM_YEAR_COUNT)
        with(self()) {
            startYear?.let {
                addQueryParam(QUERY_PARAM_START_YEAR, it.toString())
            } ?: run {
                if (yearBoundsRequired) {
                    throw IllegalStateException("startYear is required but was not set")
                }
            }
            yearCount?.let {
                addQueryParam(QUERY_PARAM_YEAR_COUNT, it.toString())
            } ?: run {
                if (yearBoundsRequired) {
                    throw IllegalStateException("yearCount is required but was not set")
                }
            }
            acceptJson()
        }
        return super.build()
    }

    override fun clear(): B {
        startYear = null
        yearCount = null
        return super.clear()
    }

    companion object {
        const val QUERY_PARAM_START_YEAR = "sy"
        const val QUERY_PARAM_YEAR_COUNT = "c"
    }
}
